import { intervalToDuration } from "date-fns";

export const formatResponseTime = (diffInSeconds: number) => {
  const duration = intervalToDuration({
    start: 0,
    end: Math.abs(diffInSeconds) * 1000,
  });

  const { hours, minutes, seconds } = duration;

  if (hours && !minutes) {
    return `${hours} ${hours === 1 ? "hour" : "hours"}`;
  }

  if (hours) {
    return `${hours}h. ${minutes}m.`;
  }

  if (diffInSeconds >= 3600) {
    const totalHours = Math.floor(diffInSeconds / 3600);
    const remainingMinutes = Math.floor((diffInSeconds % 3600) / 60);
    return `${totalHours}h. ${remainingMinutes}m.`;
  }

  if (diffInSeconds >= 60) {
    const roundedMinutes = Math.round(Math.abs(diffInSeconds) / 60);
    return `${roundedMinutes} ${roundedMinutes === 1 ? "minute" : "minutes"}`;
  }

  return `${seconds || 0} ${seconds === 1 ? "second" : "seconds"}`;
};
